export default __webpack_public_path__ + "static/Intly_Promo_slutlig-0456457b634983a0efd2d4ba78d224a3.mp4";